import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChild,
  ElementRef,
  NgZone
} from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { WebappService } from '../../../service/webapp.service';
import { Router } from '@angular/router';
import { isDefined } from '@angular/compiler/src/util';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as _moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimeAdapter } from 'ng-pick-datetime';
const moment = (_moment as any).default ? (_moment as any).default : _moment;
declare let google;
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnDestroy {
  index
  dialogVisible: boolean;
  availCategorySum: any;
  categoryId: any;
  pickupDefault: String = 'Set Pickup Location';
  dropDefault: String = 'Set Drop Location';
  paymentType: String = 'cash';
  availCategories: any;
  serviceAvailable: boolean;
  profilelog: any;
  profileid: any;
  intervalId: any;
  currencySymbol: any = '$';
  closeResult: string;
  rideType: any;
  minDate: any;
  maxDate: any;
  minTime: any;
  scheduleTimeError: any;
  scheduleTimeWrong: any;
  scheduledOn: any;
  minscheduledOn: any;
  scheduledAt: any;
  rideData: object;
  dateTime : any;
  constructor(
    private element: ElementRef,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private translate: TranslateService,
    private apiservice: WebappService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public toastr: ToastrService,
    
  ) {
    this.dateTime = new moment();
    this.scheduleTimeError = false;
    this.scheduleTimeWrong = false;
    this.dialogVisible = false;
    this.availCategorySum = 0;
    this.serviceAvailable = false;
    this.rideType = 'requested';
    this.minDate = new Date();
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 7);
  }

  ngOnInit() {

    this.appConfig();

    if (localStorage.getItem('pickup_location')) {
      this.pickupDefault = localStorage.getItem('pickup_location');
    }

    if (localStorage.getItem('drop_location')) {
      this.dropDefault = localStorage.getItem('drop_location');
    }

    if (
      !localStorage.getItem('pickup_location') ||
      !localStorage.getItem('drop_location')
    ) {
      this.apiservice.showallcategories().subscribe(data => {
        if (data['status'] === 'true') {
          this.serviceAvailable = true;
          this.availCategories = data['categories'];
          this.availCategorySum = data['count'];
          this.categoryId = data['categories'][0]._id;
        } else {
          this.serviceAvailable = false;
        }
      });
    }

    this.availableCategories();
    this.intervalId = setInterval(() => this.availableCategories(), 5000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  availableCategories() {
    this.mapsAPILoader.load().then(() => {
      if (
        localStorage.getItem('pickup_location') &&
        localStorage.getItem('drop_location')
      ) {
        let distance = new google.maps.DistanceMatrixService().getDistanceMatrix(
          {
            origins: [localStorage.getItem('pickup_location')],
            destinations: [localStorage.getItem('drop_location')],
            travelMode: 'DRIVING'
          },
          (results: any) => {
            let ride_distance = parseFloat(
              results.rows[0].elements[0].distance.text
            );
            let requestData = {
              pickup_lat: localStorage.getItem('pickup_lat'),
              pickup_lng: localStorage.getItem('pickup_lon'),
              pickup_location: localStorage.getItem('pickup_location'),
              drop_lat: localStorage.getItem('drop_lat'),
              drop_lng: localStorage.getItem('drop_lon'),
              drop_location: localStorage.getItem('drop_location'),
              distance: ride_distance
            };
            this.apiservice
              .shownearbycategories(requestData)
              .subscribe(data => {
                if (data['status'] === 'true') {
                  this.serviceAvailable = true;
                  this.availCategorySum = data['count'];
                  this.availCategories = data['available_ride'];
                } else {
                  this.serviceAvailable = false;
                }
              });
          }
        );
      }
    });
  }

  requestRide(category) {
    this.profilelog = JSON.parse(localStorage.getItem('user'));
    if (isDefined(this.profilelog)) {
      this.profileid = this.profilelog.id;
      if (!this.paymentType) {
        this.paymentType = 'cash';
      }

      this.rideData = {
        user_id: this.profileid,
        category_id: category._id,
        payment_type: this.paymentType,
        type: this.rideType,
        baseprice: category.baseprice,
        pickup_lat: localStorage.getItem('pickup_lat'),
        pickup_lng: localStorage.getItem('pickup_lon'),
        pickup_location: localStorage.getItem('pickup_location'),
        drop_lat: localStorage.getItem('drop_lat'),
        drop_lng: localStorage.getItem('drop_lon'),
        drop_location: localStorage.getItem('drop_location')
      };

      if (this.rideType == 'schedule' && !this.scheduledAt) {
        this.scheduleTimeError = true;
        return false;
      }

      if (this.scheduleTimeWrong) {
        return false;
      }

      if (this.rideType == 'schedule' && this.scheduledAt) {
        let scheduleStarts = this.scheduledAt;
        scheduleStarts.setHours(scheduleStarts.getHours() + 5);
        scheduleStarts.setMinutes(scheduleStarts.getMinutes() + 30);
        this.rideData['schedule_time'] = Math.round(scheduleStarts.getTime() / 1000);
      }

      this.apiservice.requestride(this.rideData).subscribe(data => {
        if (data['status'] === 'true') {
          if (this.rideType === 'requested') {
            /* this.router.navigate(['/confirm-booking']); */
            this.router.navigate(['/confirm-booking'], { queryParams: { 'categoryPrice': category.baseprice }, skipLocationChange: true });
          } else {
            this.toastr.success(this.translate.instant('Your ride has been scheduled'));
            this.router.navigate(['/your-rides']);
          }
        } else {
          // this.toastr.error(this.translate.instant('Something went to be wrong'));
          // this.router.navigate(['/search']);
          this.router.navigate(['/signin']);
        }
      });
    } else {
      this.router.navigate(['/signin']);
    }
  }

  scheduleDialog(schedulefor) {
    if (schedulefor == 1) {
      this.dialogVisible = true;
      this.rideType = 'schedule';
    } else {
      this.dialogVisible = false;
      this.rideType = 'requested';
      this.scheduleTimeError = false;
      this.scheduleTimeWrong = false;
      this.scheduledAt = "";
      this.dateTime = "";
    }
  }

  changePayment(type) {
    this.paymentType = type;
  }

  openNav() {
    const $sideNav = $('.sidenav');
    const $overlayDiv = $('.overlay_div');
    const $menuImg = $('.menu_img');
    /* if ($(window).width() >= 450) { */
    $sideNav.css('width', '300px');
    $overlayDiv.css('display', 'block');
    $menuImg.css('display', 'none');
    document.getElementsByTagName('body')[0].classList.add('overflow_div');
    document.getElementsByTagName('body')[0].classList.add('pos_rel');
  }

  closeNav() {
    const $sideNav = $('.sidenav');
    const $overlayDiv = $('.overlay_div');
    const $menuImg = $('.menu_img');
    $sideNav.css('width', '-300px');
    $overlayDiv.css('display', 'none');
    $menuImg.css('display', 'inline-block');
    document.getElementsByTagName('body')[0].classList.remove('overflow_div');
    document.getElementsByTagName('body')[0].classList.add('pos_rel');
  }

  appConfig() {
    this.apiservice.appconfig().subscribe(data => {
      if (data['status'] === 'true') {
        this.currencySymbol = data['currencysymbol'];
        localStorage.setItem('CS', this.currencySymbol);
      }
    });
  }

  onScheduleChange(data) {
    this.scheduledAt = data;
    this.scheduleTimeError = false;
    this.scheduleTimeWrong = false;
    this.scheduledOn = Math.round(data.getTime() / 1000);
    let now = new Date();
    now.setMinutes(now.getMinutes() + 15);
    this.minscheduledOn = Math.round(now.getTime() / 1000);
    if (this.scheduledOn <= this.minscheduledOn) {
      this.scheduleTimeWrong = true;
    }
  }

}
